var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import styled from 'styled-components';
import { designSchema } from '../../../contexts/designs/utils';
import { LARGE_BREAKPOINT } from '../../../utils/constants';
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-row-gap: 16px;\n\n  @media (min-width: ", "px) {\n    grid-row-gap: 16px;\n  }\n\n  ", ";\n"], ["\n  display: grid;\n  grid-row-gap: 16px;\n\n  @media (min-width: ", "px) {\n    grid-row-gap: 16px;\n  }\n\n  ", ";\n"])), LARGE_BREAKPOINT, designSchema);
var templateObject_1;
